// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#fff","menuText":"#ff9700","menuActiveText":"#ff9700","subMenuBg":"#fff"};